import React from "react";
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    useTheme,
} from "@mui/material";

const DatasetDetailSchemaTable = ({ schema }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                mt: 2,
                p: 2,
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 2,
                width: "100%",
                backgroundColor: theme.palette.background.paper,
            }}
        >
            <Typography variant="h6" gutterBottom>
                Data Attributes
            </Typography>
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell
                                sx={{
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    backgroundColor: theme.palette.action.hover,
                                    border: `1px solid ${theme.palette.divider}`,
                                }}
                            >
                                Field
                            </TableCell>
                            <TableCell
                                sx={{
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    backgroundColor: theme.palette.action.hover,
                                    border: `1px solid ${theme.palette.divider}`,
                                }}
                            >
                                Type
                            </TableCell>
                            <TableCell
                                sx={{
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    backgroundColor: theme.palette.action.hover,
                                    border: `1px solid ${theme.palette.divider}`,
                                }}
                            >
                                Description
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Object.entries(schema).map(([field, meta]) => (
                            <TableRow key={field}>
                                <TableCell
                                    sx={{
                                        fontSize: "13px",
                                        border: `1px solid ${theme.palette.divider}`,
                                    }}
                                >
                                    {field}
                                </TableCell>
                                <TableCell
                                    sx={{
                                        fontSize: "13px",
                                        border: `1px solid ${theme.palette.divider}`,
                                    }}
                                >
                                    {meta?.type || "N/A"}
                                    {meta?.format ? ` (${meta.format})` : ""}
                                </TableCell>
                                <TableCell
                                    sx={{
                                        fontSize: "13px",
                                        border: `1px solid ${theme.palette.divider}`,
                                    }}
                                >
                                    {meta?.description || "No description available"}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default DatasetDetailSchemaTable;
